import { render, staticRenderFns } from "./DGrid.vue?vue&type=template&id=5c000190"
import script from "./DGrid.vue?vue&type=script&lang=ts"
export * from "./DGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports